import React from "react";
import { Routes, Route } from 'react-router-dom';
import { randomId } from '@mui/x-data-grid-generator';

import Routing from './components/config/Routing';

// Login route
import Logout from './components/page/Login/Logout';
import LoginAuth from './components/page/Login/LoginAuth';
import LoginRenewPassword from './components/page/Login/LoginRenewPassword';
import LoginRenewPasswordDone from './components/page/Login/LoginRenewPasswordDone';
import LoginSetNewPassword from './components/page/Login/LoginSetNewPassword';
import LoginSetNewPasswordDone from './components/page/Login/LoginSetNewPasswordDone';

// Content route
import Home from './components/page/Content/Home/Home';
import TrainingSearch from './components/page/Content/Training/TrainingSearch/TrainingSearch';
import TrainingStaffing from "./components/page/Content/Training/TrainingStaffing/TrainingStaffing";

function App() {
  return (
    <Routes>
      <Route path="*" element={<Routing key={randomId()} />} />

      <Route path="/deconnexion" element={<Logout key={randomId()} />} />
      <Route path="/authentification" element={<LoginAuth key={randomId()} />} />
      <Route path="/renouvelerMotDePasse" element={<LoginRenewPassword key={randomId()} />} />
      <Route path="/renouvelerMotDePasse/confirmation" element={<LoginRenewPasswordDone key={randomId()} />} />
      <Route path="/nouveauMotDePasse" element={<LoginSetNewPassword key={randomId()} />} />
      <Route path="/nouveauMotDePasse/confirmation" element={<LoginSetNewPasswordDone key={randomId()} />} />

      <Route path="/accueil" element={<Home key={randomId()} />} />
      <Route path="/formation/recherche" element={<TrainingSearch key={randomId()} />} />
      <Route path="/formation/resultat" element={<TrainingStaffing key={randomId()} />} />
    </Routes>
  );
}

export default App;
